import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/presentation/SimplePresentationRunner";
import {HOTB} from "../../HOTB";
import {gsap} from "gsap";
import {GameConfig} from "../../GameConfig";
import {GameUtils} from "../../utils/GameUtils";
import {GameSounds} from "../../sound/GameSounds";

export class WinCapPresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline;

    shouldRun(): boolean {
        return HOTB.model.gameData.brokeTheBank;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline({
            delay: GameConfig.MAX_WIN_START_DELAY
        });

        this._mainTl.add((): void => {
            if (GameUtils.isSatanSpin()) {
                GameSounds.soundPlayer.fadeTrack({
                    name: HOTB.soundPlayer.satanSpinSoundPlaying,
                    to: 0,
                    duration: 0.001
                });
            }
            HOTB.soundPlayer.fadeMusic(0, 0.01);
            HOTB.keypadPlugin.setZeroBetSpinCounter(-1);
            HOTB.winCap.showView((): void => {
                controller.finish();
            });
        })

        this._mainTl.add((): void => {
            /*controller.setSkipCallback((): void => {
                this.onSkip();
            });*/
            controller.setSkipCallback();
        }, 0.001);
    }

    private onSkip(): void {
        // do nothing for now
        // this._mainTl.progress(1);
    }
}